var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs_wrap"},_vm._l((_vm.items),function(item,index){return _c('router-link',{key:item.pathName + index,attrs:{"to":{ name: item.pathName, params: {id: item.item_id || null} }}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }